import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
//STYLES
import styled, { css } from "styled-components"
import { down } from "styled-breakpoints"
import { Text, H2 } from "../utils/typo"
//Components
import SEO from "../components/seo/SEO"
import Layout from "../layout/layout2"
import { ContainerMob, Section } from "../utils/utils"
import Baner from "../components/baner/Baner"

const variantOptions = {
  left: {
    bgColor: props => props.theme.color.base6,
    direction: "ltr",
    templateCol: "23fr 10fr",
  },
  right: {
    bgColor: props => props.theme.color.base3,
    direction: "rtl",
    templateCol: "23fr 10fr",
  },
  leftpodproduct: {
    bgColor: props => props.theme.color.base6,
    direction: "ltr",
    templateCol: "2fr 1fr",
  },
  rightpodproduct: {
    bgColor: props => props.theme.color.base3,
    direction: "rtl",
    templateCol: "2fr 1fr",
  },
  centerproduct: {
    templateCol: "1fr",
  },
}

const OpisWrapper = styled(Section)`
  > div {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    max-width: 1600px;
    position: relative;
    z-index: 10;
    margin-top: ${props => props.mt || "0rem"};
    margin-bottom: ${props => props.mb || "0rem"};

    display: grid;
    grid-template-columns: 23fr 10fr;
    column-gap: 3rem;

    ${down("lg")} {
      max-width: 1200px;
    }

    ${down("md")} {
      max-width: 960px;
    }

    ${down("sm")} {
      margin-top: ${props => props.mtMobile || "0rem"};
      max-width: 720px;
      padding-right: 1rem;
      padding-left: 1rem;
    }

    ${down("xs")} {
      max-width: 540px;
      padding-right: 1rem;
      padding-left: 1rem;
      grid-template-columns: 1fr;
    }

    span {
      display: flex;
      flex-direction: column;
      > div {
        justify-self: start;
        align-self: flex-start;
        width: 100%;
        height: 100%;
      }
    }
  }

  ${({ variant }) =>
    variant &&
    variantOptions[variant] &&
    css`
      background-color: ${variantOptions[variant].bgColor};
      > div {
        direction: ${variantOptions[variant].direction};
        ul,
        p {
          direction: ltr;
        }

        ${down("xs")} {
          direction: unset;
        }
      }
    `}
`

const ProduktWrapper = styled(OpisWrapper)`
  > div:first-of-type {
    grid-template-columns: ${props => props.template || "1fr 1fr"};
    row-gap: 2rem;
    ${down("sm")} {
      grid-template-columns: 1fr;
    }

    span:first-of-type {
      > div {
        padding: 3rem;
        width: 70%;
        align-self: center;
      }
    }
  }

  > div:nth-of-type(2) {
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 3rem;
    row-gap: 2rem;
    ${down("xs")} {
      grid-template-columns: 1fr;
    }
  }
`

const Produktowe = ({ pageContext, data }) => {
  let { page } = data

  return (
    <div>
      <SEO title="Home" slug="/page3" />
      <Layout lang={pageContext.locale} slug={pageContext.slug}>
        <Baner
          image={page.baner.gatsbyImageData}
          alt="Baner - grupa kapitałowa"
          height="2rem"
          heading={page.heading}
          align="right"
        />
        <ContainerMob mt="2rem" mb="4rem">
          <Text dangerouslySetInnerHTML={{ __html: page.intro }} />
        </ContainerMob>

        {page.opis.length === 0 ? (
          <></>
        ) : (
          <ProduktWrapper>
            {page.opis.map(element => {
              return (
                <OpisWrapper
                  key={page.opis.indexOf(element)}
                  variant={
                    page.opis.indexOf(element) % 2 === 1 ? "left" : "right"
                  }
                >
                  <div>
                    <span>
                      <Text
                        dangerouslySetInnerHTML={{ __html: element.text }}
                      />
                    </span>

                    <span>
                      <GatsbyImage
                        image={element.img.gatsbyImageData}
                        alt={page.heading}
                        objectFit="contain"
                      />
                    </span>
                  </div>
                </OpisWrapper>
              )
            })}
          </ProduktWrapper>
        )}

        {page.podprodukt.length === 0 ? (
          <></>
        ) : (
          <ProduktWrapper>
            {page.podprodukt.map(element => {
              return (
                <ProduktWrapper
                  key={page.podprodukt.indexOf(element)}
                  variant={
                    page.podprodukt.indexOf(element) % 2 === 1
                      ? "leftpodproduct"
                      : "rightpodproduct"
                  }
                  template={element.img === null ? "1fr" : "1fr 1fr"}
                >
                  <div className="info">
                    <span>
                      <H2>{element.heading}</H2>
                      {element.opis === null ? (
                        <></>
                      ) : (
                        <Text
                          dangerouslySetInnerHTML={{ __html: element.opis }}
                        />
                      )}

                      {element.logo === null ? (
                        <></>
                      ) : (
                        <GatsbyImage
                          image={element.logo.gatsbyImageData}
                          alt={element.heading}
                          objectFit="contain"
                        />
                      )}
                    </span>
                    {element.img === null ? (
                      <></>
                    ) : (
                      <span>
                        <GatsbyImage
                          image={element.img.gatsbyImageData}
                          alt={page.heading}
                          objectFit="contain"
                        />
                      </span>
                    )}
                  </div>
                  <div>
                    {element.galeria === null ? (
                      <></>
                    ) : (
                      element.galeria.map(img => {
                        return (
                          <GatsbyImage
                            key={element.galeria.indexOf(img)}
                            image={img.gatsbyImageData}
                            alt={img.title}
                            objectFit="contain"
                          />
                        )
                      })
                    )}
                  </div>
                </ProduktWrapper>
              )
            })}
          </ProduktWrapper>
        )}
      </Layout>
    </div>
  )
}
export default Produktowe

export const query = graphql`
  query ProduktoweQuery($locale: String!, $slug: String!) {
    page: datoCmsPodstronyProduktowe(
      locale: { eq: $locale }
      slug: { eq: $slug }
    ) {
      locale
      slug
      heading
      intro
      baner {
        gatsbyImageData
      }
      opis {
        id
        text
        img {
          isImage
          gatsbyImageData
        }
      }
      podprodukt {
        heading
        opis
        img {
          gatsbyImageData
        }
        galeria {
          gatsbyImageData
          title
        }
        logo {
          gatsbyImageData
        }
      }

      doPobrania {
        url
        title
        format
      }
    }
  }
`
